import { useSyncExternalStore } from "react";
import { getChatSession } from "../chat/use-chat";
import { getWorkspaceSession } from "../workspace/use-workspace";
import { getIdentityStore } from "./identity";
import { getRoomController } from "./use-room";

export function useIdentity() {
  const store = getIdentityStore();
  return useSyncExternalStore(
    (listener) => store.subscribe(listener),
    () => store.get(),
  );
}

/** Pushes identity changes everywhere they're shown: peers (hello/profile), cursors, chat. */
export function syncIdentity(): void {
  const store = getIdentityStore();
  store.subscribe(() => {
    const identity = store.get();
    getRoomController().setProfile(identity);
    getWorkspaceSession().setProfile(identity);
    getChatSession().setIdentity(identity);
  });
}
